import AlternativeDomFactory from '../factory/alternative-factory';
import QuizDomFactory from '../factory/quiz-factory';
import Alternative from '../model/alternative';
import { mountAlternativeId, shuffleAlternatives } from '../utils/alternative';
import AlternativeBuilder from './alternative-builder';
import Builder from '../../common/builder/builder';

type WithCheckboxOptions = {
  onCheckAnswer: (alternative: Alternative) => void;
  disabled?: boolean;
};

export default class QuizBuilder extends Builder<
  {
    wrapper: HTMLElement;
    title?: HTMLElement;
    alternativesContainer?: HTMLElement;
  },
  QuizDomFactory
> {
  private randomize: boolean;

  constructor(factory: QuizDomFactory, randomize: boolean) {
    super(factory);
    this.randomize = randomize;
  }

  public withTitle(title: string) {
    this.elements.wrapper?.appendChild(this.factory.createTitle(title));
    return this;
  }

  public withContent(content?: string) {
    if (content) {
      this.elements.wrapper?.appendChild(this.factory.createContent(content));
    }
    return this;
  }

  public withAlternativesContainer() {
    this.elements.alternativesContainer =
      this.factory.createAlternativesContainer();
    this.elements.wrapper?.appendChild(this.elements.alternativesContainer);
    return this;
  }

  public withAlternatives(
    alternatives: Alternative[],
    options: WithCheckboxOptions,
  ) {
    const alternativesShunffle = this.randomize
      ? shuffleAlternatives(alternatives)
      : alternatives;
    alternativesShunffle.forEach(alternative => {
      const alternativeBuilder = new AlternativeBuilder(
        new AlternativeDomFactory(this.factory.i18n),
      );
      alternativeBuilder.withId(mountAlternativeId(alternative.getId()));
      alternativeBuilder.withLetter(alternative.getLetter());
      alternativeBuilder.withAnswer(alternative.getAnswer());
      alternativeBuilder.withStatus(alternative.getStatus());

      alternativeBuilder.withCheckbox(
        () => options.onCheckAnswer(alternative),
        options.disabled,
      );

      this.elements.alternativesContainer?.appendChild(
        alternativeBuilder.build(),
      );
    });
    return this;
  }
}
